import React, { useState } from "react";
//@MUI
import { Button, Tooltip, Typography, Filter } from "@material-ui/core";
import {
  ArrowSquareIn,
  LineSegments,
  Plus,
  Share,
  Funnel,
} from "phosphor-react";
import { useHistory } from "react-router";
import {
  FilterButton,
  SortButton,
  TableViewToggleButtons,
  ToggleButton,
} from "../../CommonComponents/CommonButtons/CommonButtons.Component";
import BreadCrumb from "../../Utilities/BreadCrumb/BreadCrumb.jsx";
import TrackableStats from "../../Utilities/TrackableStats/TrackableStats";
import AddBulkAddButtons from "../../Utilities/Add&BulkAddButtons/Add&BulkAddButtons.jsx";
import useStyle from "./AssetVersionsTools.styles";
import CommonFilterComponent from "../../Utilities/CommonFilterComponent/CommonFilterComponent.jsx";

function AssetVersionsTools(props) {
  const classes = useStyle();
  const history = useHistory();
  const [openButtonPopover, setOpenButtonPopover] = useState(null);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const handleButtonPopoverClick = (event) => {
    setOpenButtonPopover(event.currentTarget);
  };

  const handleButtonPopoverClose = () => {
    setOpenButtonPopover(null);
  };

  return (
    <div className={classes.root}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <BreadCrumb
          shotCode={props?.parentAsset ? props?.parentAsset.name : ""}
        />
        <TrackableStats
          stats={props.assetVersionStats}
          type={"Asset Versions"}
        />
      </div>
      <div className={classes.divContainerRight}>
        <Tooltip title="See Timeline" placement="top">
          <Button
            className={classes.timelineButton}
            onClick={props.handleOpenTimelineModal}
          >
            <LineSegments size={20} />
            <Typography style={{ marginLeft: "4px" }}>Timeline</Typography>
          </Button>
        </Tooltip>
        <Tooltip title="See Tasks" placement="top">
          <Button
            style={{ minWidth: "25px", padding: "2px" }}
            onClick={(event) => {
              event.stopPropagation();
              history.push(`/${props.projectId}/assets/${props?.assetID}/task`);
            }}
          >
            <ArrowSquareIn height={25} width={25} />
          </Button>
        </Tooltip>
        <div>
          <ToggleButton handleToggler={props?.handleAssetToggler} />
        </div>
        <TableViewToggleButtons
          isTogglerOn={props.isToggleView}
          handleToggle={props.handleToggleView}
        />
        <div>
          <SortButton
            onSubmit={props?.onSubmit}
            defaultvalue={props?.defaultValue}
          />
        </div>
        <div>
          <FilterButton
            btnActive={props?.filterButtonActive}
            openFilterModal={props?.handleFilterModalState}
          />
        </div>
        <Button
          size="small"
          variant="outlined"
          title="Filter"
          style={{
            border: "2px solid #6C65D9",
            borderRadius: "10px",
            padding: "10px",
            textTransform: "none",
            color: "white",
          }}
          onClick={() => setIsFilterDrawerOpen(true)}
        >
          <Funnel size={20} />
        </Button>
        <Button
          size="small"
          variant="outlined"
          style={{
            border: "2px solid #6C65D9",
            borderRadius: "10px",
            padding: "10px",
            textTransform: "none",
            color: "white",
            "&:hover": {
              border: "2px solid #6C65D9",
              backgroundColor: "#252A38",
            },
          }}
          onClick={props.handleOpenExportModal}
        >
          <Share size={20} />
        </Button>
        <Button
          size="small"
          id="assetVersion"
          className={classes.buttonEditAssetandNewVersion}
          onClick={handleButtonPopoverClick}
          disableElevation
        >
          <Plus size={18} style={{ marginRight: "4px" }} />
          New
        </Button>
        <AddBulkAddButtons
          openButtonPopover={openButtonPopover}
          handleButtonPopoverClose={handleButtonPopoverClose}
          openNewModal={props?.openNewAssetVerisonModal}
          openImportModal={props?.handleOpenBulkImportModal}
          trackableType="assetversion"
          newLabel="New Asset Version"
        />
      </div>
      <CommonFilterComponent
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        trackableType="assetversion"
        projectId={props.projectId}
      />
    </div>
  );
}

export default AssetVersionsTools;
